import type { DownloadRequest } from '@dmp/api/api.types';
import type { StateCreator } from 'zustand';

import type { DownloadRequestPolling } from './DownloadRequestPolling';

export type DownloadRequestsState = {
  datasetDownloadRequests: DownloadRequest[];
  isFetchingDownloadRequests: boolean;
  isFetchingDatasetRequests: boolean;
  downloadRequestPolling: DownloadRequestPolling | null;

  downloadRequestsCurrentPage: number;
  downloadRequestsPageSize: number;
  downloadRequestsTotal: number;

  downloadRequestsSorter: {
    columnKey: string;
    order: 'asc' | 'desc' | null;
  } | null;
};

export const initialDownloadRequestsState: DownloadRequestsState = {
  datasetDownloadRequests: [],
  isFetchingDownloadRequests: false,
  isFetchingDatasetRequests: false,
  downloadRequestPolling: null,
  downloadRequestsCurrentPage: 1,
  downloadRequestsPageSize: 10,
  downloadRequestsTotal: 0,
  downloadRequestsSorter: {
    columnKey: 'created_on',
    order: 'desc',
  },
};

export const createDownloadRequestsSlice: StateCreator<DownloadRequestsState> = () => initialDownloadRequestsState;
